import React, { useState, useEffect } from 'react'
import { OmInput, OmDropdownMenu } from '@owma/kit'
import chevronDownThick16 from 'assets/images/chevron-down-thick-16.svg'
import styles from './style.module.scss'
import deleteIcon from 'assets/images/button-remove.svg'

interface LabelItem {
  key: string
  label: string
}

interface DynamicLabelInputProps {
  id: string
  index: number
  label: string
  value: string
  labelList: LabelItem[]
  getDropDownInfoList?: ((label: string) => LabelItem[]) | null
  canDelete?: boolean
  onValueChange: (id: string, value: string) => void
  onLabelChange: (id: string, label: string) => void
  onDelete: (id: string, index: number) => void
  inputFieldsRender?: ((index: number) => React.ReactNode) | null
}

function DynamicLabelInput({
  id,
  index,
  label,
  value,
  labelList,
  getDropDownInfoList = null,
  canDelete = true,
  onValueChange,
  onLabelChange,
  onDelete,
  inputFieldsRender = null,
}: DynamicLabelInputProps) {
  const [innerLabelList, setInnerLabelList] = useState<LabelItem[]>(labelList)

  useEffect(() => {
    if (getDropDownInfoList) {
      const list = getDropDownInfoList(label)
      setInnerLabelList(list)
    }
  }, [getDropDownInfoList, label])

  const getLabel = () => {
    const findData = innerLabelList.find((item) => item.key === label)
    if (findData) {
      return findData.label
    }
    return label
  }

  const handleDelete = () => {
    if (canDelete) {
      console.log('delete', id, index)
      onDelete(id, index)
    } else {
      onValueChange(id, '')
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.labelWrapper}>
        <OmDropdownMenu
          menu={{
            items: innerLabelList.map((item) => ({
              key: item.key,
              label: item.label,
            })),
            onClick: ({ key }) => onLabelChange(id, key),
          }}
          trigger={['click']}
          overlayClassName="contextMenu"
        >
          <span className={styles.label}>
            {getLabel()}
            <img src={chevronDownThick16} alt="chevron-down" />
          </span>
        </OmDropdownMenu>
      </div>
      <div className={styles.inputWrapper}>
        {inputFieldsRender ? (
          inputFieldsRender(index)
        ) : (
          <OmInput
            value={value}
            onChange={(value) => onValueChange(id, value)}
            className={styles.input}
          />
        )}
        {!(canDelete !== true && (value ?? '').length === 0) && (
          <div className={styles.deleteButton} onClick={handleDelete}>
            <img src={deleteIcon} alt="delete" />
          </div>
        )}
      </div>
    </div>
  )
}

export default DynamicLabelInput
